import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/'},
]

class TamaulipasDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    render(){
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Visita Tamaulipas' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                
                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--4"  data-black-overlay="7">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">VISITA TAMAULIPAS</h2>
                                    <p>Gestión de turismo de la ciudad de Tamaulipas. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Portfolio Details */}
                <div className="rn-portfolio-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="portfolio-details">
                                    <div className="inner">
                                        <h1>Visita Tamaulipas App - Tu Guía de Turismo</h1>
                                        <h3>Aplicación móvil para la gestión del turismo en el estado de Tamaulipas</h3>
                                        <p>Descubre la aplicación líder para explorar el turismo en Tamaulipas. Encuentra hoteles, restaurantes y experiencias únicas en la ciudad de Tamaulipas.</p>
                                        <p>Nuestra aplicación incluye un panel de administrador que permite a los usuarios agregar hoteles con disponibilidad de habitaciones, experiencias con manejo de tickets y restaurantes con sus deliciosos menús.</p>
                                        <p>Además, los usuarios pueden realizar pagos dentro de la aplicación para reservar estos servicios y tienen la opción de dejar sus opiniones y puntuaciones sobre los establecimientos, compartiendo sus experiencias con otros viajeros.</p>
                                        <p>Este emocionante proyecto fue solicitado por el Gobierno de Tamaulipas y estará disponible al público a finales de 2023.</p>

                                        <div className="portfolio-view-list d-flex flex-wrap">
                                            <div className="port-view">
                                                <span>Framework Frontend</span>
                                                <h4>Flutter (Móvil)</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Framework Backend</span>
                                                <h4>Laravel</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Lenguajes</span>
                                                <h4>Dart & PHP</h4>
                                            </div>
                                        </div>

                                        <div className="portfolio-share-link mt--20 pb--70 pb_sm--40">
                                            <div className="header-btn">
                                                <a className="rn-btn" href="#">Ver app en Play Store (Próximamente)</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Portfolio Details */}

                {/* Start Related Work */}
                <div className="portfolio-related-work pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <span className="theme-color font--18 fontWeight600">Otros proyectos</span>
                                    <h2>Proyectos relacionados</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row mt--10">
                            {/* Start Single Portfolio */}
                            <div className="col-lg-6 col-md-6 col-12 text-center">
                                <div className="related-work text-center mt--30">
                                    <div className="thumb">
                                        <a href="/tamaulipas-web-details">
                                            <img src="/assets/images/portfolio/dp-portfolio-02.jpg" alt="Portfolio-images"/>
                                        </a>
                                    </div>
                                    <div className="content">
                                        <div className="inner">
                                            <p>Página web - Laravel</p>
                                            <h4><a href="/tamaulipas-web-details">Gestión de turismo de la ciudad de Tamaulipas</a></h4>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        </div>
                    </div>
                </div>
                {/* End Related Work */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />  


            </React.Fragment>
        )
    }
}
export default TamaulipasDetails;
